import React from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

export default function Contents() {
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col>
                    <h3 className="mb-0">Contenidos Autogestión</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row className="mb-3">
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/enlaces">
                      <Button color="primary" size="md">
                        Enlaces dinámicos
                      </Button>
                    </Link>
                  </Col>
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/novedades">
                      <Button color="primary" size="md">
                        Novedades
                      </Button>
                    </Link>
                  </Col>
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/banner-minimo-etico">
                      <Button color="primary" size="md">
                        Banner del Mínimo Ético
                      </Button>
                    </Link>
                  </Col>
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/enlaces-aranceles">
                      <Button color="primary" size="md">
                        Enlaces de Aranceles
                      </Button>
                    </Link>
                  </Col>
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/enlaces-formularios">
                      <Button color="primary" size="md">
                        Enlaces de Formularios
                      </Button>
                    </Link>
                  </Col>
                </Row>
                <Row className="mb-3 mt-6">
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/normas">
                      <Button color="primary" size="md">
                        Normas de Facturación
                      </Button>
                    </Link>
                  </Col>
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/modulos-obras-sociales">
                      <Button color="primary" size="md">
                        Módulos Obras Sociales
                      </Button>
                    </Link>
                  </Col>
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/modulos-ioma">
                      <Button color="primary" size="md">
                        Módulos IOMA
                      </Button>
                    </Link>
                  </Col>
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/modulos-especialidad">
                      <Button color="primary" size="md">
                        Módulos Especialidad
                      </Button>
                    </Link>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/modulos-otras-practicas">
                      <Button color="primary" size="md">
                        Otras Prácticas Kinésicas
                      </Button>
                    </Link>
                  </Col>
                  <Col md="3" style={{ textAlign: 'center' }}>
                    <Link to="/admin/contenidos/reglamento-obras-sociales">
                      <Button color="primary" size="md">
                        Reglamento Interno OOSS
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
